import { ContactType, ContactStatus } from 'shared/types';

export const generateSecurePassword = (): string => {
  const chars = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  
  let password = '';
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += chars[Math.floor(Math.random() * chars.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];
  
  for (let i = 4; i < 10; i++) {
    const allChars = chars + numbers + symbols + uppercase;
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }
  
  // Shuffle the password
  return password.split('').sort(() => Math.random() - 0.5).join('');
};

export const getContactTypeBadgeVariant = (type: ContactType): string => {
  const variants = {
    contact: 'primary',
    lead: 'success',     
    archive: 'secondary'
  };
  return variants[type] || 'secondary';
};

export const getContactStatusBadgeVariant = (status: ContactStatus): string => {
  const variants = {
    pending: 'secondary',     
    in_process: 'info',      
    conversion: 'success',   
    failure: 'danger'        
  };
  return variants[status] || 'secondary';
};

export const formatContactStatus = (status: ContactStatus): string => {
  return status.replace('_', ' ');
};

export interface ContactFormData {
  name: string;
  phoneNumber: string;
  email: string;
  age: string;
  address: string;
  type: ContactType;
  status: ContactStatus;
  assigned: string;
}

export const validateContactForm = (formData: ContactFormData): Record<string, string> => {
  const errors: Record<string, string> = {};
  
  if (!formData.name.trim()) {
    errors.name = 'Name is required';
  }
  
  if (!formData.phoneNumber.trim()) {
    errors.phoneNumber = 'Phone is required';
  }
  
  if (!formData.email.trim()) {
    errors.email = 'Email is required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }
  
  if (!formData.age || parseInt(formData.age) < 1 || parseInt(formData.age) > 150) {
    errors.age = 'Please enter a valid age (1-150)';
  }
  
  if (!formData.address.trim()) {
    errors.address = 'Address is required';
  }
  
  return errors;
};

export const generateDefaultUsername = (email: string, phoneNumber: string): string => {
  return email || phoneNumber;
};
